import * as stateManagement from '#packages/stateManagement';

export const {
  isDraggingSel,
  isResizingSel,
  isRotatingSel,
  isDuringMouseActionSel,
} = stateManagement.stateMapperArgsSelectors.mouseSels;
